module.exports = "<div class=\"container\">\n\n  <mibig-submission></mibig-submission>\n</div>\n";